module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="grid-x">\n    <div class="large-6 small-12 text-center large-text-left" style="padding:0">\n      <h2 class="header-logo display-inline-block"><a href="/"><span class="site-logo unsigned">Courtmenow</span></a></h2>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/user-logged-out-header.html
// module id = 303
// module chunks = 0